<template>
    <div class="pd15">
        <a-row class="">
            <div class="flex mt15 mb15" style="justify-content: space-between;">
                <div class="flex items-center">
                    <img class="ml15 mr10" src="../../../public/images/guigeguanli.png" style="width:25px;height:25px" />
                    <div class="ml0 fs14" style="color:grey">废料出售统计表</div>
                </div>
            </div>
        </a-row>
        <div class="bg-white pd20">
            <a-tabs default-active-key="1" >
                <a-tab-pane key="1" tab="废料出售明细">
                    <a-row class="flex">
                        <div class="flex" >
                            <div class="flex items-center">
                                <a-input size="small" allowClear class="mb10 ml10" v-model="searchInput1" placeholder="请输入关键字" style="width: 300px" enter-button @change="allowSupplierClear1" @pressEnter="() => onSearch1(selectedKeys, confirm, column.field)" />
                            </div>
                            <div v-if="selectDate == 0" class="flex ml10">
                                <a-date-picker
                                    size="small"
                                    v-model="beginDate"
                                    value-format="YYYY-MM-DD"
                                    :disabled-date="disabledStartDate"
                                    show-time
                                    format="YYYY-MM-DD"
                                    placeholder="开始日期"
                                    @openChange="handleStartOpenChange"
                                    @change="onBeginChange"
                                    class="mr10"
                                    :locale="locale"
                                />
                                <a-date-picker
                                    size="small"
                                    v-model="endDate"
                                    value-format="YYYY-MM-DD"
                                    :disabled-date="disabledEndDate"
                                    show-time
                                    format="YYYY-MM-DD"
                                    placeholder="结束日期"
                                    :locale="locale"
                                />
                            </div>
                            <a-button size="small" class="ml10" type="primary" icon="search" @click="onSearch1">
                                查询
                            </a-button>
                        </div>
                        <!-- <div  style="position: absolute;right:0;">
                            <a-button class="flex items-center" @click="goExportCsv(1)">
                                <img src="images/wenjiandaochu.png" style="width:25px;height: 25px;" />
                                <div class="fs14">导出</div>
                            </a-button>
                        </div> -->
                    </a-row>
                    
                    <a-row :gutter="24" type="flex" align="stretch">
                        <!-- Table -->
                        <a-col :span="24" :lg="30" class="">
                            <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0,}">
                                <a-table :data-source="data1" :columns="columns1" class="pd15 w100"  :pagination="false" size="small" bordered :loading="loading">
                                    <div
                                        slot="filterProject"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px;width:500px;"
                                    >
                                        <div class="flex items-center" style="justify-content: space-between;">
                                            <div>已选中{{ProjectCheckedList.length}}项</div>
                                            <div>
                                                <a-input-search placeholder="输入关键字" v-model="projectSearch" size="small" :compact="true" />
                                            </div>
                                        </div>
                                        <!-- <a-table
                                            :row-selection="{ selectedRowKeys: projectRowKeys, onChange: onSelectChange }"
                                            :columns="projectColumns"
                                            :data-source="projectsList"
                                        /> -->
                                        <a-table class="mt10" :row-selection="rowSelection" :columns="projectColumns"  :pagination="{ pageSize: 10 }" :data-source="projectsList"  size="small"/>
                                        <div style="text-align:right">
                                            <a-button
                                                type="primary"
                                                icon="search"
                                                size="small"
                                                style="width: 90px; margin-right: 8px"
                                                @click="onSearch1"
                                            >
                                                确定
                                            </a-button>
                                            <a-button size="small" style="width: 90px" @click="() => handleReset1(clearFilters)">
                                                清空条件
                                            </a-button>
                                        </div>
                                    </div>
                                    <template slot="total_price" slot-scope="text,record">
                                        <div>{{ record.total_price / 100 }}</div>
                                    </template>
                                    <template slot="sale_unit_price" slot-scope="text,record">
                                        <div>{{ record.sale_unit_price / 100 }}</div>
                                    </template>
                                    
                                </a-table>
                                <a-pagination 
                                    class="flex items-center mb10"
                                    style="justify-content: flex-end"
                                    show-quick-jumper  
                                    v-model="page1.page" 
                                    :total="page1.total" 
                                    :page-size="30"
                                    @change="onShowSizeChange1" 
                                />
                            </a-card>
                        </a-col>
                    </a-row>
                </a-tab-pane>
                <a-tab-pane key="2" tab="废料出售统计">
                    <a-row class="flex">
                        <a-select size="small" default-value="date" style="width: 120px" @change="changeTime">
                            <a-select-option value="date">
                                按日查询
                            </a-select-option>
                            <a-select-option value="month">
                                按月查询
                            </a-select-option>
                        </a-select>
                        <div class="flex items-center">
                            <a-input size="small" allowClear class="mb10 ml10 mr10" v-model="searchInput2" placeholder="请输入关键字" style="width: 300px" enter-button @change="allowSupplierClear2" @pressEnter="onSearch2" />
                        </div>
                        <div v-if="selectDate == 0" class="flex">
                            <a-date-picker
                                size="small"
                                v-model="beginDate"
                                value-format="YYYY-MM-DD"
                                :disabled-date="disabledStartDate"
                                show-time
                                format="YYYY-MM-DD"
                                placeholder="开始日期"
                                @openChange="handleStartOpenChange"
                                @change="onBeginChange"
                                class="mr10"
                                :locale="locale"
                            />
                            <a-date-picker
                                size="small"
                                v-model="endDate"
                                value-format="YYYY-MM-DD"
                                :disabled-date="disabledEndDate"
                                show-time
                                format="YYYY-MM-DD"
                                placeholder="结束日期"
                                :locale="locale"
                            />
                        </div>
                        <a-month-picker size="small" v-else placeholder="选择月份" valueFormat="chooseMonth" @change="onMonthChange" />
                        <a-button size="small" class="ml10" type="primary" icon="search" @click="onSearch2">
                            查询
                        </a-button>
                        <!-- <div style="position: absolute;right:0;">
                            <a-button class="flex items-center" @click="goExportCsv(2)">
                                <img src="images/wenjiandaochu.png" style="width:25px;height: 25px;" />
                                <div class="fs14">导出</div>
                            </a-button>
                        </div> -->
                    </a-row>
                    
                    <a-row :gutter="24" type="flex" align="stretch">
                        <!-- Table -->
                        <a-col :span="24" :lg="30" class="">
                            <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0,}">
                                <a-table :data-source="data2" :columns="columns2" class="pd15 w100"  :pagination="false" size="small" bordered>
                                    <div
                                        slot="filterProject"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px;width:500px;"
                                    >
                                        <div class="flex items-center" style="justify-content: space-between;">
                                            <div>已选中{{ProjectCheckedList.length}}项</div>
                                            <div>
                                                <a-input-search placeholder="输入关键字" v-model="projectSearch" size="small" :compact="true" />
                                            </div>
                                        </div>
                                        <!-- <a-table
                                            :row-selection="{ selectedRowKeys: projectRowKeys, onChange: onSelectChange }"
                                            :columns="projectColumns"
                                            :data-source="projectsList"
                                        /> -->
                                        <a-table class="mt10" :row-selection="rowSelection" :columns="projectColumns"  :pagination="{ pageSize: 10 }" :data-source="projectsList"  size="small"/>
                                        <div style="text-align:right">
                                            <a-button
                                                type="primary"
                                                icon="search"
                                                size="small"
                                                style="width: 90px; margin-right: 8px"
                                                @click="onSearch1"
                                            >
                                                确定
                                            </a-button>
                                            <a-button size="small" style="width: 90px" @click="() => handleReset2(clearFilters)">
                                                清空条件
                                            </a-button>
                                        </div>
                                    </div>
                                    <template slot="total_price" slot-scope="text,record">
                                        <div>{{ record.total_price / 100 }}</div>
                                    </template>
                                </a-table>
                                <a-pagination 
                                    class="flex items-center mb10"
                                    style="justify-content: flex-end"
                                    show-quick-jumper  
                                    v-model="page2.page" 
                                    :total="page2.total" 
                                    :page-size="30"
                                    @change="onShowSizeChange2" 
                                />
                            </a-card>
                        </a-col>
                    </a-row>
                </a-tab-pane>
            </a-tabs>
        </div>
    </div>
</template>
<script>
    import locale from 'ant-design-vue/es/date-picker/locale/zh_CN'

    export default {
        components: {
    
        },
        data() {
            return {
                locale,
                data1:[],
                data2:[],
                selectID:1,
                selectDate:0,   //0 按日期 1 按月份
                searchInput1: "",
                searchInput2: "",
                beginDate:"",
                endDate:"",
                chooseMonth:"",
                endOpen:false,
                columns1: [
                    {
                        title: '项目名称', key: 'project_name',
                        dataIndex: "project_name", field: "project_name", ellipsis: true,
                        scopedSlots: { filterDropdown: 'filterProject', filterIcon: 'filterIcon'}, 
                        customFilterDropdown: true,
                        onFilter: (value, record) => {},
                        onFilterDropdownVisibleChange: visible => {},
                        width: '15%',
                    },
                    // {
                    //     title: '项目名称',
                    //     dataIndex: 'project_name',
                    //     key: 'project_name',
                    //     width: '15%',
                    // },
                    {
                        title: '物资名称',
                        dataIndex: 'material_name',
                        key: 'area',
                        width: '15%',
                    },
                    {
                        title: '备注',
                        dataIndex: 'remark',
                        key: 'remark',
                        ellipsis: true,
                    },
                    {
                        title: '出售数量',
                        dataIndex: 'count',
                        key: 'count',
                        width: '10%',
                    },
                    {
                        title: '单价',
                        dataIndex: 'sale_unit_price',
                        key: 'sale_unit_price',
                        scopedSlots: { customRender: 'sale_unit_price' },
                    },
                    {
                        title: '总价',
                        dataIndex: 'total_price',
                        key: 'total_price',
                        scopedSlots: { customRender: 'total_price' },
                    },
                    {
                        title: '时间',
                        dataIndex: 'create_time',
                        key: 'create_time',
                        width: '15%',
                        // scopedSlots: { customRender: 'operation' },
                    }
                ],
                columns2: [
                    {
                        title: '项目名称', key: 'project_name',
                        dataIndex: "project_name", field: "project_name", ellipsis: true,
                        scopedSlots: { filterDropdown: 'filterProject', filterIcon: 'filterIcon'}, 
                        customFilterDropdown: true,
                        onFilter: (value, record) => {},
                        onFilterDropdownVisibleChange: visible => {},
                        width: '15%',
                    },
                    {
                        title: '物资名称',
                        dataIndex: 'material_name',
                        key: 'material_name',
                        width: '15%',
                    },
                    {
                        title: '备注',
                        dataIndex: 'remark',
                        key: 'remark',
                        ellipsis: true,
                    },
                    {
                        title: '出售数量',
                        dataIndex: 'count',
                        key: 'count',
                    },
                    {
                        title: '总金额',
                        dataIndex: 'total_price',
                        key: 'total_price',
                        scopedSlots: { customRender: 'total_price' },
                    },
                    {
                        title: '时间',
                        dataIndex: 'create_time',
                        key: 'create_time',
                        width: '15%',
                    }
                ],
                page1:{
                    page:1,
                    total:0
                },
                page2:{
                    page:1,
                    total:0
                },
                search:"",
                loading: false,
                ProjectCheckedList:[],
                selectedRows: [], // 已选择的行
                allSelectedRows: [], // 存储所有已选择的行，初始时与 selectedRows 相同
                projectColumns:[{title: '项目名称', key: "name", dataIndex: "name", align:"center"},],
                project_list:[],
                projectSearch:"",
                searchList:[],

            }
        },
        computed:{
            rowSelection() {
                return {
                    selectedRowKeys: this.allSelectedRows.map(row => row.key),
                    onChange: (selectedRowKeys, selectedRows) => {
                        this.selectedRows = selectedRows
                        this.allSelectedRows = selectedRows;
                        let pitem = this.searchList.find(it=>it.field == "project_name")
                        this.ProjectCheckedList = []
                        if(selectedRows.length == 0){
                            if(pitem != null){
                                this.searchList = this.searchList.filter(it=>it.key != pitem.key)
                            }
                        }else{
                            // this.ProjectCheckedList = []
                            let pname = ""
                        
                            for(let item of selectedRows){
                                pname = (pname.length == 0)?item.name:(pname + "、" + item.name)
                                this.ProjectCheckedList.push(item.id)
                            }
                            if(pitem == null){
                                this.searchList.push({key:this.searchList.length, field:"project_name", label: "项目名称:", value:pname})
                            }else{
                                pitem.value = pname
                            }
                        }
                    },
                    getCheckboxProps: record => ({
                        props: {
                            disabled: record.name === 'Disabled User', // Column configuration not to be checked
                            name: record.name,
                        },
                    }),
                };
            },
            projectsList() {
                if (this.projectSearch == "") {
                    return this.project_list;
                } else {
                    return this.project_list.filter((it) => {
                        if (it.name != null) {
                            return (it.name.indexOf(this.projectSearch) != -1) 
                        }
                    });
                }
            },

        },
        created(){
            this.getScrapSaleRecord()
            this.getScrapSaleSummary()
            this.getProjectList()
        },
        methods:{
            async getScrapSaleRecord(){
                let plist = JSON.stringify(this.ProjectCheckedList)
                this.loading = true;
                let rs = await this.$api.getScrapSaleRecord(this.searchInput1, plist, this.page1.page - 1, 30, this.beginDate, this.endDate)
                if(rs.err == 0){
                    this.page1.total = rs.data.total
                    for(var i = 0; i < rs.data.list.length;i++){
                        rs.data.list[i].key = i + 1;
                        rs.data.list[i].create_time = rs.data.list[i].create_time.replace("T", " ")
                    }
                    this.data1 = rs.data.list
                    this.loading = false;
                }

            },
            async getScrapSaleSummary(){
                let plist = JSON.stringify(this.ProjectCheckedList)
                this.loading = true;
                let rs = await this.$api.getScrapSaleSummary(this.searchInput2, plist, this.page2.page - 1, 30, this.beginDate, this.endDate, this.chooseMonth, this.selectDate)
                if(rs.err == 0){
                    this.page2.total = rs.data.total
                    this.data2 = rs.data.list
                    for(var i = 0; i < this.data2.length;i++){
                        this.data2[i].key = i + 1;
                    }
                    this.loading = false;

                }
            },
            async onSearch1(selectedKeys, confirm, dataIndex){
                // if((this.searchInput1 == "") && (this.beginDate == "") && (this.endDate == "")){
                //     this.$notification['warning']({
                //         message: '查询条件为空',
                //         description:
                //         '请输入关键字进行查询',
                //         style: {
                //             width: '600px',
                //             marginLeft: `${335 - 600}px`,
                //         },
                //     });
                //     return;
                // } 
                if (selectedKeys.length > 0 && selectedKeys[0] != null && selectedKeys[0] != "") {
                    let value = selectedKeys[0];
                    let item = this.search_field.find(it=>it.field == dataIndex)
                    if(item != null){
                        item.value = value
                    }else{
                        this.search_field.push({key:this.search_field.length, field:dataIndex, value:value})
                    }
                    let item2 = this.searchList.find(it=>it.field == dataIndex)
                    if(item2 != null){
                        item2.value = value
                    }else{
                        let part = this.columns.find(it=>it.field == dataIndex)
                        if(part != null){
                            this.searchList.push({key:this.searchList.length, field:dataIndex, label: (part.title + ":"), value:value})
                        }
                    }
                }
                this.page1.page = 1
                this.getScrapSaleRecord()
            },
            async onSearch2(){
                // if((this.searchInput2 == "") && (this.beginDate == "") && (this.endDate == "")&&(this.chooseMonth == "")){
                //     this.$notification['warning']({
                //         message: '查询条件为空',
                //         description:
                //         '请输入关键字或选择日期进行查询',
                //         style: {
                //             width: '600px',
                //             marginLeft: `${335 - 600}px`,
                //         },
                //     });
                //     return;
                // } 
                this.page2.page = 1
                this.getScrapSaleSummary()
            },
            onShowSizeChange1() {
                this.getScrapSaleRecord()
            },
            onShowSizeChange2() {
                this.getScrapSaleSummary()
            },
            allowSupplierClear1(){
                if(this.searchInput1.length == 0){
                    this.page1.page = 1
                    this.getScrapSaleRecord()
                }
            },
            allowSupplierClear2(){
                if(this.searchInput2.length == 0){
                    this.page2.page = 1
                    this.getScrapSaleSummary()
                }
            },
            disabledStartDate(startValue) {
                const endValue = this.endValue;
                if (!startValue || !endValue) {
                    return false;
                }
                return startValue.valueOf() > endValue.valueOf();
            },
            disabledEndDate(endValue) {
                const startValue = this.startValue;
                if (!endValue || !startValue) {
                    return false;
                }
                return startValue.valueOf() >= endValue.valueOf();
            },
            handleStartOpenChange(open) {
                if (!open) {
                    this.endOpen = true;
                }
            },
            handleEndOpenChange(open) {
                this.endOpen = open;
            },
            onBeginChange(date, dateString){
                this.beginDate = dateString
            },
            onEndChange(date, dateString){
                this.endDate = dateString
            },
            onMonthChange(date, dateString){
                this.chooseMonth = dateString
            },
            changeTime(){
                this.selectDate = (this.selectDate == 1)? 0 : 1
                this.getScrapSaleSummary()
            },
            async goExportCsv(id){
                let rs = await this.$api.goExportCsv(this.searchInput2, this.beginDate, this.endDate, this.chooseMonth, this.selectDate, id)  
            },
            async getProjectList(){
                let rs = await this.$api.getProjectList()
                if(rs.err == 0){
                    let ca = 1
                    for(let item of rs.data){
                        item.key = ca
                        ca++
                    }
                    this.project_list = rs.data
                }
            },
            handleReset1(clearFilters) {
                clearFilters();
                this.ProjectCheckedList = []
                this.selectedRows = [];
                this.allSelectedRows = []; // 清空存储的所有已选择的行
                this.page1.page = 1
                this.getScrapSaleRecord()
            },
            handleReset2(clearFilters) {
                clearFilters();
                this.ProjectCheckedList = []
                this.selectedRows = [];
                this.allSelectedRows = []; // 清空存储的所有已选择的行
                this.page2.page = 1
                this.getScrapSaleSummary()
            },
           
        }

    }

</script>

<style lang="scss" scoped>
.flow-item {
    cursor: pointer;
    border: 1px solid rgba(0,0,0,0.1);
    padding: 5px 5px 5px 5px;
    font-size: 12px;
}
.select-flow-item {
    cursor: pointer;
    position: relative;
    .item {
        border-bottom: 1px solid rgba(0,0,0,0.1);
        padding: 5px 5px 5px 5px;
        font-size: 12px;
    }
}
.select-flow-item:not(:last-child):after {
    content: "";
    position: absolute;
    right: -10px;
    top: 23px;
    height: 2px;
    width: 10px;
    background: #d8d8d8;
}
.user_group {
    list-style-type: none;
    margin: 0;
    padding-left: 20px;
    padding-top: 10px;

    li {
        height: 30px;
        border: 1px solid rgba(0,0,0,0.05);
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        cursor: pointer;

        &.active {
            background: #67C23A;
            color: white;
        }
    }
}
</style>

<style scoped>
/deep/.ant-table {
    font-size: 13px!important;
}
/deep/.ant-table-thead > tr > th {
    font-size: 14px!important;
}


</style>

<style lang="scss" scoped>
.m-attachment {
    padding: 5px;
    transition: all 0.3s;
    .m-close {
        opacity: 0;
        transition: all 0.3s;
    }
}
.m-attachment:hover {
    background-color: #f5f5f5;
    transition: all 0.3s;
    .m-close {
        opacity: 1;
        transition: all 0.3s;
    }
}
// .customer-checkbox .ant-checkbox-group-item {
//     width: 100%;
// }
</style>

<style scoped>
/deep/.ant-table-thead {
    background: #f0f2f5;
}
/deep/.ant-drawer-content {
    overflow: visible;
}
/deep/.ant-form-item {
    margin-bottom: 13px!important;
}
/deep/.ant-table {
    font-size: 13px!important;
}

</style>
  